import { render, staticRenderFns } from "./AgentCommissions.vue?vue&type=template&id=d5e4356e&scoped=true&"
import script from "./AgentCommissions.vue?vue&type=script&lang=js&"
export * from "./AgentCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e4356e",
  null
  
)

export default component.exports